import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';

type CreateUserRows = {
  label: string;
  id: vp.CreateUserId;
  preset: keyof vp.TextFieldPresets | undefined;
};

const buildCreateUserRows = (): CreateUserRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.CreateUser.buildCreateUserRows' });
  return [
    {
      label: t('email'),
      id: vp.CreateUserId.EmailAddress,
      preset: 'email',
    },
  ];
};
export default buildCreateUserRows;
